'use client';

import type { ComponentProps } from 'react';
import { Skeleton } from '@ghq-abi/design-system-v2';

import { cn } from '~/shared/utils/cn';

type SkeletonsProp = {
  quantity: number;
  width?: number | string;
  height?: number | string;
} & Omit<ComponentProps<typeof Skeleton>, 'children'>;

export function Skeletons({
  quantity = 1,
  width,
  height,
  className,
  style,
  ...rest
}: SkeletonsProp) {
  return (
    <>
      {Array.from({ length: quantity }, (_, i) => i).map(i => (
        <Skeleton
          key={i}
          className={cn('w-full min-h-12.5 m-0', className)}
          style={{ width, height, ...style }}
          {...rest}
        />
      ))}
    </>
  );
}
